import errorStackParser from "error-stack-parser";

/**
 * @returns Minimized stack, containing only one line suggesting the version of the app.
 */
export function minimizeStack(error: Error) {
  try {
    return errorStackParser.parse(error)[0].toString();
  } catch (parseError) {
    console.error("Failed to minimize stack", parseError);
    return null;
  }
}

/**
 * @returns Whether `error` relates to a request abort using `signal`.
 */
export function isRequestAbortError(error: any) {
  if (!error) {
    return;
  }

  //  Chrome
  return error.name === "AbortError";
}